<template>
  <div id="topbar-mobile">
    <div class="fixed">
      <img class="image-layout" alt="Flowers" src="../assets/banner.jpg">
      <h1 style="margin-top:-15px">The New Norms</h1>
      <h3 style="margin-top:-25px">Earn From Home</h3>
      <div>
        <Slide width="250" :closeOnNavigation="true">
          <a id="home">
            <router-link to="/">Home</router-link>
          </a>
          <a id="image">
            <router-link to="/image">Images</router-link>
          </a>
          <a id="testimony">
            <router-link to="/testimony">Testimony</router-link>
          </a>
          <a id="admin">
            <router-link to="/admin">Admin</router-link>
          </a>
          <Socialmedia />
        </Slide>
      </div>
    </div>
    <div class="content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'
import Socialmedia from './Socialmedia.vue'
export default {
  components: {
    Slide, // Register your component
    Socialmedia
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/common.scss";

.fixed {
  height: 185px;
  left: 0px;
  right: 0px;
  top: 0px;
  position: fixed;
  background: white;
  z-index: 1000;
}

a {
font-weight: bold;
color: $inactive-colour;
text-decoration:none;
white-space: nowrap;

&.router-link-exact-active {
  color: $active-colour;
  }
}

.content {
  margin-top: 200px;
}

/deep/ .bm-burger-button {
  left: 18px;
  top: 18px;
}
</style>
